import { create } from 'zustand';

const initialVideoState = {
  id: null,
  slug: null,
  autosave_token: null,
  title_id: '',
  title_en: '',
  content_id: '',
  content_en: '',
  short_description_id: '',
  short_description_en: '',
  video_url: '',
  hospital_id: '',
  doctor_ids: [],
  doctor_names: [],
  thumbnail: null,
  thumbnail_url: null,
  remove_thumbnail: false,
  meta_description: '',
  meta_keywords: '',
  tag_list: [],
  category_list: [],
  updated_at: null,
  has_publish_record: false,
  published: false
};

const useVideoStore = create((set, get) => ({
  ...initialVideoState,

  // Autosave status
  saveStatus: 'idle', // idle | saving | saved | error
  lastSavedAt: null,
  publishErrors: {},

  // Dirty tracking
  _lastSavedState: null,

  resetStore: () => {
    set({ ...initialVideoState, saveStatus: 'idle', lastSavedAt: null, publishErrors: {}, _lastSavedState: null });
  },

  setVideo: (video) => {
    const state = { ...initialVideoState, ...video };
    set({ ...state, _lastSavedState: state });
  },

  updateField: (field, value) => {
    set({ [field]: value });
  },

  updateFields: (fields) => {
    set(fields);
  },

  setSaveStatus: (status) => {
    set({ saveStatus: status });
    if (status === 'saved') {
      set({ lastSavedAt: new Date() });
    }
  },

  markSaved: (newToken) => {
    const current = get();
    const savedState = {};
    Object.keys(initialVideoState).forEach(key => {
      savedState[key] = current[key];
    });
    set({
      autosave_token: newToken,
      saveStatus: 'saved',
      lastSavedAt: new Date(),
      _lastSavedState: savedState
    });
  },

  setPublishErrors: (errors) => {
    set({ publishErrors: errors });
  },

  getChangedFields: () => {
    const current = get();
    const lastSaved = current._lastSavedState || initialVideoState;

    const changed = {};
    Object.keys(initialVideoState).forEach(key => {
      if (key === 'thumbnail' && current[key] instanceof File) {
        changed[key] = current[key];
      } else if (JSON.stringify(current[key]) !== JSON.stringify(lastSaved[key])) {
        changed[key] = current[key];
      }
    });
    return changed;
  },

  hasUnsavedChanges: () => {
    const current = get();
    const lastSaved = current._lastSavedState || initialVideoState;

    return Object.keys(initialVideoState).some(key => {
      if (key === 'thumbnail' && current[key] instanceof File) return true;
      return JSON.stringify(current[key]) !== JSON.stringify(lastSaved[key]);
    });
  }
}));

export default useVideoStore;
